const o = "_container_1ryxo_1", _ = "_primary_1ryxo_12", r = "_active_1ryxo_23", e = "_secondary_1ryxo_29", s = "_verified_1ryxo_45", i = "_reviewed_1ryxo_60", n = "_xs_1ryxo_75", c = "_sm_1ryxo_85", t = "_md_1ryxo_95", y = "_lg_1ryxo_105", a = "_isLoading_1ryxo_119", d = {
  container: o,
  primary: _,
  active: r,
  secondary: e,
  verified: s,
  reviewed: i,
  xs: n,
  sm: c,
  md: t,
  lg: y,
  isLoading: a
};
export {
  r as active,
  o as container,
  d as default,
  a as isLoading,
  y as lg,
  t as md,
  _ as primary,
  i as reviewed,
  e as secondary,
  c as sm,
  s as verified,
  n as xs
};
//# sourceMappingURL=IconButton.module.css.js.map
